import { ONBOARDING_STAR_TWINKLE_CYCLE_S } from "./constants";

export const randomOnboardingStarDelays = (): [number, number, number, number] =>
  [
    Math.random() * ONBOARDING_STAR_TWINKLE_CYCLE_S,
    Math.random() * ONBOARDING_STAR_TWINKLE_CYCLE_S,
    Math.random() * ONBOARDING_STAR_TWINKLE_CYCLE_S,
    Math.random() * ONBOARDING_STAR_TWINKLE_CYCLE_S,
  ];
